import Alpine from 'alpinejs'

Alpine.data('asxPrice', () => ({
    price: null,
    changeStr: null,
    lastUpdated: null,
    formatChange(m, p) {
        const s = m >= 0 ? '+' : '';
        return s + m.toFixed(2) + ' (' + s + p.toFixed(2) + '%)';
    },
    formatDate(dt) {
        const d = dt.split('T')[0].split('-');
        const t = dt.split('T')[1].split(':');
        const months = ['January','February','March','April','May','June','July','August','September','October','November','December'];
        return d[2] + ' ' + months[+d[1]-1] + ' ' + d[0] + ' ' + t[0] + ':' + t[1] + ' AEST';
    },
    async fetchPrice() {
        try {
            const r = await fetch('https://wcsecure.weblink.com.au/Clients/aspengroup/pricejson.aspx');
            const data = await r.json();
            const q = data.quote[0];
            this.price = 'APZ ' + q.lastprice.toFixed(2) + ' AUD';
            this.changeStr = this.formatChange(q.movement, q.movementPercent);
            this.lastUpdated = this.formatDate(q.datetime);
        } catch(e) { console.error('[asx-price]', e) }
    },
    init() {
        this.fetchPrice();
        setInterval(() => this.fetchPrice(), 60000);
    },
}))
